


































helpers = require('../../helpers.coffee')

view_model = {
  data: ->
    current_user: Session.current_user
    default_user: Session.current_user
    current_day: true
    current_date: new Date
    height: 0
    loading: true
    hours: [
      { hour: 0, events: [] }
      { hour: 1, events: [] }
      { hour: 2, events: [] }
      { hour: 3, events: [] }
      { hour: 4, events: [] }
      { hour: 5, events: [] }
      { hour: 6, events: [] }
      { hour: 7, events: [] }
      { hour: 8, events: [] }
      { hour: 9, events: [] }
      { hour: 10, events: [] }
      { hour: 11, events: [] }
      { hour: 12, events: [] }
      { hour: 13, events: [] }
      { hour: 14, events: [] }
      { hour: 15, events: [] }
      { hour: 16, events: [] }
      { hour: 17, events: [] }
      { hour: 18, events: [] }
      { hour: 19, events: [] }
      { hour: 20, events: [] }
      { hour: 21, events: [] }
      { hour: 22, events: [] }
      { hour: 23, events: [] }
    ]
    search_date: new Date

  watch:
    height: ->
      @newHeight()

  methods:
    loadEvents: ->
      return @loading = false if !@valid_calendar_id
      for hour in @hours
        hour.events = []

      params = {
        starts_after: Math.floor(@search_date.setHours(0,0,0,0) /1000),
        ends_before: Math.floor(@search_date.setHours(23,59,59,999) /1000)
      }

      @loading = true

      jQuery.ajax({
        url: process.env.NYLAS_URL + "/events?expand_recurring=true&starts_after=#{params.starts_after}&ends_before=#{params.ends_before}&calendar_id=#{@current_user.nylas_setting.calendar_id}",
        type: 'GET',
        headers: {
          'Authorization': @current_user.nylas_setting.access_token
        },
        success: this.successLoadEvents,
        error: this.failureLoadEvents
      });

    newHeight: ->
      if @valid_calendar_id
        @height = (window.innerHeight - 215)
      else
        @height = (window.innerHeight - 118)

    successLoadEvents: (response) ->
      for event in response
        if !event.when.start_time
          event.when.start_time = event.when.time

        start_time = new Date(event.when.start_time * 1000)
        @hours[start_time.getHours()].events = []
        @hours[start_time.getHours()].events.push(event)

        if !event.when.end_time
          event.when.end_time = event.when.time + 1800

        end_time = new Date(event.when.end_time * 1000)
        event.start_time = this.pad(start_time.getHours()) + ":" + this.pad(start_time.getMinutes())
        event.end_time = this.pad(end_time.getHours()) + ":" + this.pad(end_time.getMinutes())
        event.height = 50
        event.length = end_time.getHours() - start_time.getHours()

        if end_time.getMinutes() > 0
          event.length += 1
        event.size = event.length

      @loading = false

    failureLoadEvents: ->
      Loader.off()
      @loading = false

    changeDay: (day) ->
      @search_date.setDate( @search_date.getDate() + day )
      @current_day = @search_date.getDate() == @current_date.getDate()
      @loadEvents()
      EventsBus.$emit 'manualtask-form::date', @search_date

    pad: (number) ->
      if number < 10
        number = '0' + number
      return number

    redirect: ->
      Loader.on()
      params = {
        id: @current_user.id,
        undo_nylas_connection: true
      }
      new UsersResource().update(@updateNylasConnectionSuccess, @webHookErrors, params)

    updateNylasConnectionSuccess: ->
      window.location = @nylasOauthUrl()

    nylasOauthUrl: ->
      params = jQuery.param(
        client_id: process.env.NYLAS_CLIENT_ID
        response_type: 'code'
        scopes: process.env.NYLAS_SCOPES
        login_hint: @current_user.email
        redirect_uri: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'nylas'
      )
      "https://api.nylas.com/oauth/authorize?#{params}"

    changeUser: (data) ->
      @current_user = data.user
      @loadEvents()

    changeDate: (date) ->
      @search_date = date
      @loadEvents()

  computed:
    valid_calendar_id: ->
      @current_user.nylas_setting?.calendar_id

    weekday: ->
      @search_date.toLocaleDateString('bt-br', { weekday: 'long' })

  created: ->
    EventsBus.$on 'daily-events::user', @changeUser
    EventsBus.$on 'daily-events::date', @changeDate

  mounted: ->
    window.addEventListener 'resize', @newHeight
    @height = (window.innerHeight)

    @loadEvents()

  beforeDestroy: ->
    EventsBus.$off 'daily-events::user', @changeUser
    EventsBus.$off 'daily-events::date', @changeDate
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/daily_events.vue